// extracted by mini-css-extract-plugin
module.exports = {"positionsList":"PositionPage_positionsList__s6BTL","formContainer":"PositionPage_formContainer__KQxDK","contentContainer":"PositionPage_contentContainer__hnE8j"};